import { render, staticRenderFns } from "./FitshowApp.vue?vue&type=template&id=4a896a11&"
import script from "./FitshowApp.vue?vue&type=script&lang=js&"
export * from "./FitshowApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports